const initialState = {
  chatList: [],
  chatMessagesList: [],
  groups: [],
  selectedChat: {},
  participantsForGroup: [],
  participantsForForwardedMessage: [],
  presenceStatus: undefined,
  isUserInformationOpen: false,
  refreshAvatar: 0,
  avatarVersions: {},
  file: null,
  dragOver: false,
  messageLoadingStatus: false,
  currentMessages: new Map(),
  currentMessage: undefined,
  lastChats: [],
  messageImageOpenId: undefined,
};

const messagingManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_CHATS": {
      const chatList = action.payload;
      return { ...state, chatList };
    }
    case "SET_MESSAGE_LOADING": {
      const status = action.payload;
      return { ...state, messageLoadingStatus: status };
    }
    case "SET_CURRENT_MESSAGES": {
      const groupId = action.payload.groupId;
      const message = action.payload.message;
      state.currentMessages.set(groupId, message);
      return { ...state };
    }
    case "CLEAR_CURRENT_MESSAGES": {
      const groupId = action.payload;
      state.currentMessages.delete(groupId);
      let currentMessage = state.currentMessages.get(groupId);
      return { ...state, currentMessage };
    }
    case "GET_CURRENT_MESSAGE": {
      const groupId = action.payload;
      let currentMessage = state.currentMessages.get(groupId);
      return { ...state, currentMessage: currentMessage };
    }
    case "SET_USER_INFORMATION_OPEN": {
      return { ...state, isUserInformationOpen: action.payload };
    }
    case "SELECT_CHAT": {
      const selected = action.payload;
      // Sohbete girince badge anında sıfırlansın; sunucu mark_seen ile senkronlanır
      const chatList = (state.chatList || []).map((c) =>
        selected?.id && c.id === selected.id ? { ...c, unreadCount: 0 } : c
      );
      if (selected?.id !== state.selectedChat?.id) {
        return {
          ...state,
          selectedChat: selected,
          chatList,
          isUserInformationOpen: false,
          presenceStatus: undefined,
          chatMessagesList: [],
        };
      }
      return {
        ...state,
        selectedChat: selected,
        chatList,
        isUserInformationOpen: false,
        presenceStatus: undefined,
      };
    }
    case "SELECT_REPLY_MESSAGE": {
      const selectedReplyMessage = action.payload;
      return { ...state, selectedReplyMessage: selectedReplyMessage };
    }
    case "SELECT_FORWARD_MESSAGE": {
      const selectedForwardMessage = action.payload;
      return { ...state, selectedForwardMessage: selectedForwardMessage };
    }
    case "ADD_NEW_MESSAGE": {
      const messageList = action.payload;
      const positionEnd = action.positionEnd;
      const groupId = action.groupId;
      const increaseUnreadCount = action.increaseUnreadCount;

      state.chatList.map((l) => {
        if (l.id === groupId && messageList) {
          l.lastMessage = messageList[messageList.length - 1];
          l.lastMessageId = messageList[messageList.length - 1].id;
        }
      });

      let chatListRemoved = state.chatList.filter((l) => l.id !== groupId);

      let chatListFirst = state.chatList.filter((l) => l.id === groupId);

      const isActiveChat = state.selectedChat?.id === groupId;
      // Açık sohbetteyken okunmamış sayacı artırma
      if (increaseUnreadCount && !isActiveChat) {
        state.chatList.forEach((c) => {
          if (c.id === groupId) {
            if (c.unreadCount === null || c.unreadCount === undefined)
              c.unreadCount = 0;
            c.unreadCount++;
          }
        });
      }

      if (isActiveChat) {
        if (positionEnd)
          return {
            ...state,
            chatList: [...chatListFirst, ...chatListRemoved],
            chatMessagesList: [...state.chatMessagesList, ...messageList],
          };
        return {
          ...state,
          chatList: [...chatListFirst, ...chatListRemoved],
          chatMessagesList: [...messageList, ...state.chatMessagesList],
        };
      }
      return {
        ...state,
        chatList: [...chatListFirst, ...chatListRemoved],
      };
    }
    case "ADD_CHAT_LIST": {
      const chatlist = action.payload;
      return {
        ...state,
        chatList: [...chatlist, ...state.chatList],
      };
    }
    case "SELECT_PARTICIPANTS": {
      const participants = action.payload;
      return { ...state, participantsForGroup: participants };
    }
    case "SELECT_PARTICIPANTS_FOR_FORWARDED": {
      const participantsForForwardedMessage = action.payload;
      return {
        ...state,
        participantsForForwardedMessage: participantsForForwardedMessage,
      };
    }
    case "MARK_AS_SEEN_BATCH": {
      const groupId = action.payload.groupId;
      const meId = action.payload.meId;
      const idSet = new Set(action.payload.messageIds || []);

      const chatList = (state.chatList || []).map((c) => {
        if (c.id !== groupId) return c;
        return { ...c, unreadCount: 0 };
      });

      const chatMessagesList = (state.chatMessagesList || []).map((message) => {
        if (!idSet.has(message.id)) return message;
        const unseenList = Array.isArray(message.unseenList)
          ? message.unseenList.filter((id) => id !== meId)
          : [];
        const unAckList = Array.isArray(message.unAckList)
          ? message.unAckList.filter((id) => id !== meId)
          : [];
        return { ...message, unseenList, unAckList };
      });

      return {
        ...state,
        chatList,
        chatMessagesList,
      };
    }
    case "MARK_AS_SEEN": {
      const groupId = action.payload.groupId;
      const meId = action.payload.meId;
      const messageId = action.payload.messageId;

      const chatList = (state.chatList || []).map((c) => {
        if (c.id !== groupId) return c;
        const next =
          typeof c.unreadCount === "number" && c.unreadCount > 0
            ? c.unreadCount - 1
            : 0;
        return { ...c, unreadCount: next };
      });

      const chatMessagesList = (state.chatMessagesList || []).map((message) => {
        if (message.id !== messageId) return message;
        const unseenList = Array.isArray(message.unseenList)
          ? message.unseenList.filter((id) => id !== meId)
          : [];
        return { ...message, unseenList };
      });

      return {
        ...state,
        chatList,
        chatMessagesList,
      };
    }
    case "SEND_ACK": {
      const meId = action.payload.meId;
      const messageId = action.payload.messageId;

      const chatMessagesList = (state.chatMessagesList || []).map((message) => {
        if (message.id !== messageId) return message;
        const unAckList = Array.isArray(message.unAckList)
          ? message.unAckList.filter((id) => id !== meId)
          : [];
        return { ...message, unAckList };
      });

      return {
        ...state,
        chatMessagesList,
      };
    }
    case "STARRED_MESSAGE": {
      const message = action.payload;
      let copychatMessagesList = state.chatMessagesList;
      let indexOfMessage = copychatMessagesList.findIndex(
        (item) => item.id === message.messageId
      );

      if (
        copychatMessagesList[indexOfMessage].starredBy.find(
          (i) => i === message.userId
        )
      ) {
        copychatMessagesList[indexOfMessage].starredBy = copychatMessagesList[
          indexOfMessage
        ].starredBy.filter((a) => a !== message.userId);
      } else {
        copychatMessagesList[indexOfMessage].starredBy = [
          ...copychatMessagesList[indexOfMessage].starredBy,
          message.userId,
        ];
      }
      return { ...state, chatMessagesList: [...copychatMessagesList] };
    }
    case "GET_PRESENCE_STATUS": {
      let status = action.payload;
      return { ...state, presenceStatus: status };
    }
    case "FETCH_CHAT_MESSAGES": {
      const chatMessagesList = action.payload.list;
      const initial = action.payload.initial;
      if (initial)
        return { ...state, chatMessagesList, messageLoadingStatus: false };
      else
        return {
          ...state,
          chatMessagesList: [...chatMessagesList, ...state.chatMessagesList],
          messageLoadingStatus: false,
        };
    }
    case "SEND_MESSAGE": {
      //const me = action.payload;
      return { ...state };
    }
    case "DELETE_MESSAGE": {
      const deletedMessage = state.chatMessagesList.filter(
        (m) => !action.payload.includes(m.id)
      );
      const idx = state.chatList.findIndex((cl) =>
        action.payload.includes(cl.lastMessageId)
      );
      let deletedMessageGroup = state.chatList[idx];
      deletedMessageGroup.lastMessageId = null;
      deletedMessageGroup.lastMessage = null;
      let chatListWithoutUpdatedMessage = state.chatList.filter(
        (cl, index) => index !== idx
      );
      chatListWithoutUpdatedMessage.splice(idx, 0, deletedMessageGroup);

      return {
        ...state,
        chatMessagesList: deletedMessage,
        chatList: chatListWithoutUpdatedMessage,
      };
    }
    case "CREATE_GROUP": {
      const group = action.payload;
      if (!group?.id) {
        return { ...state, selectedChat: group, chatMessagesList: [] };
      }
      const without = (state.chatList || []).filter((c) => c.id !== group.id);
      return {
        ...state,
        selectedChat: group,
        chatMessagesList: [],
        chatList: [group, ...without],
      };
    }
    case "FIND_GROUP": {
      const group = action.payload;
      return { ...state, group };
    }
    case "DELETE_GROUP": {
      const deletedGroups = state.chatList.filter(
        (g) => !action.payload.includes(g.id)
      );
      return {
        ...state,
        chatList: deletedGroups,
        selectedChat: undefined,
        group: undefined,
      };
    }
    // case "EDIT_GROUP": {
    //   const groupsWithoutEdited = state.groups.filter(
    //     (g) => g.id !== action.payload.id
    //   );
    //   return { ...state, groups: [...groupsWithoutEdited, action.payload] };
    // }

    case "UPDATE_GROUP": {
      let groupId = action.payload.id;
      let chatListWithoutUpdatedMessage = state.chatList.filter(
        (c) => c.id !== groupId
      );

      return {
        ...state,
        chatList: [action.payload, ...chatListWithoutUpdatedMessage],
        group: action.payload,
      };
    }
    case "ARCHIVE_GROUP": {
      const { groupId, userId } = action.payload;
      const copyChatlist = [...state.chatList];
      if (
        copyChatlist[
          copyChatlist.findIndex((item) => item.id === groupId)
        ].archivedBy.includes(userId)
      ) {
        copyChatlist[
          copyChatlist.findIndex((item) => item.id === groupId)
        ].archivedBy = [
          ...copyChatlist[
            copyChatlist.findIndex((item) => item.id === groupId)
          ].archivedBy.filter((item) => item !== userId),
        ];
      } else {
        copyChatlist[
          copyChatlist.findIndex((item) => item.id === groupId)
        ].archivedBy = [
          ...copyChatlist[copyChatlist.findIndex((item) => item.id === groupId)]
            .archivedBy,
          userId,
        ];
      }
      return {
        ...state,
        chatList: copyChatlist,
        selectedChat: {},
      };
    }

    case "PIN_GROUP": {
      const chatId = action.payload.id;
      let copyChatList = [...state.chatList];
      let indexOfChat = copyChatList.findIndex((item) => item.id === chatId);
      copyChatList[indexOfChat].pinned = action.payload.pinned;
      return { ...state, chatList: [...copyChatList] };
    }

    case "ADD_PARTICIPANT_TO_GROUP": {
      return { ...state };
    }
    case "DELETE_PARTICIPANT_FROM_GROUP": {
      return { ...state };
    }
    case "LEAVE_GROUP": {
      const leftGroupId = action.payload;
      const deletedGroups = state.chatList.filter((g) => g.id !== leftGroupId);
      const leftActive = state.selectedChat?.id === leftGroupId;
      return {
        ...state,
        chatList: [...deletedGroups],
        ...(leftActive
          ? {
              selectedChat: {},
              chatMessagesList: [],
              isUserInformationOpen: false,
            }
          : null),
      };
    }
    case "ADD_ADMIN_RIGHTS": {
      return { ...state };
    }
    case "REMOVE_ADMIN_RIGHTS": {
      return { ...state };
    }
    case "REFRESH_AVATAR": {
      return { ...state, refreshAvatar: state.refreshAvatar + 1 };
    }
    case "INVALIDATE_USER_AVATAR": {
      const userId = action.payload;
      if (!userId) return state;
      const prev = state.avatarVersions[userId] || 0;
      return {
        ...state,
        avatarVersions: {
          ...state.avatarVersions,
          [userId]: prev + 1,
        },
      };
    }
    case "DROP_FILE": {
      return { ...state, file: action.payload };
    }
    case "DRAG_OVER": {
      return { ...state, dragOver: action.payload };
    }
    case "FETCH_LAST_CHATS": {
      const chatlist = action.payload;
      chatlist.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      return {
        ...state,
        lastChats: chatlist.slice(0, 5),
      };
    }
    case "SET_IMAGE_OPEN": {
      return { ...state, messageImageOpenId: action.payload };
    }
    default:
      return state;
  }
};

export default messagingManagement;
